import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { Button } from 'ui-components/components/button';
import Global from '../../../store/global-selectors';
import * as Actions from '../../../store/alerts/grid/alerts.grid.actions';
import { useCombineSplitOrdersShipmentsFeatureGate } from '../../../feature-gates/use-combine-split-orders-shipments-feature-gate';
import { messages } from './messages';

const getDisabledInfo = ({ featureGate, selectedAlertCount }) => {
  let isDisabled = false;
  let disabledReasonMessageDescriptor;

  if (!featureGate.isFeatureEnabled) {
    isDisabled = true;
    disabledReasonMessageDescriptor = featureGate.disabledMessage;
  } else if (selectedAlertCount !== 1) {
    isDisabled = true;
  }

  return {
    isDisabled,
    disabledReasonMessageDescriptor,
  };
};

const ShipTogetherButton = () => {
  const dispatch = useDispatch();
  const selectedAlertIds = useSelector(Global.selectAlertsGridgetSelectedAlertIds) || [];
  const featureGate = useCombineSplitOrdersShipmentsFeatureGate();

  const { isDisabled, disabledReasonMessageDescriptor } = getDisabledInfo({
    featureGate,
    selectedAlertCount: selectedAlertIds.length,
  });

  const isLoadingOrders = useSelector(Global.selectAlertsGridgetIsLoadingOrders);
  const isLoading = !isDisabled && isLoadingOrders;

  const onShipTogether = useCallback(() => {
    dispatch(Actions.getShipTogetherOrdersRequest());
  }, [dispatch]);

  const disabledTooltipMessage = disabledReasonMessageDescriptor ? <FormattedMessage {...disabledReasonMessageDescriptor} /> : undefined;

  return (
    <div>
      <Button
        disabled={isDisabled || isLoadingOrders}
        disabledTooltipMessage={disabledTooltipMessage}
        isLoading={isLoading}
        onClick={onShipTogether}
        theme={THEME_CONSTANTS.tertiary}
      >
        <FormattedMessage {...messages.shipTogetherButton} />
      </Button>
    </div>
  );
};

export default ShipTogetherButton;
